import { angularServicesNames } from "@topline/services/angularServicesNames";
import moment from "moment";

(function (module) {
    "use strict";
    module.service("PPGChartAndTableService", ['calculationPPGService', angularServicesNames.$translate, PPGChartAndTableService]);

    function PPGChartAndTableService(calculationPPGService: $TSFixMe, $translate: ng.translate.ITranslateService) {

        function prepareLabelsToPPG(forecastStartDate: $TSFixMe, forecastEndDate: $TSFixMe) {

            
            var year = moment(forecastStartDate);
            
            var endDate = moment(forecastEndDate);
            var result = [];
            for (; year.isSameOrBefore(endDate, 'year'); year = year.add(1, 'years')) {
                result.push(year.format('YYYY'));
            }
            return result;
        }

        function prepareQuartersLabelsToPPG(forecastStartDate: $TSFixMe, forecastEndDate: $TSFixMe) {
            
            let startDate = moment(forecastStartDate);
            
            let year = moment(forecastStartDate);
            
            let endDate = moment(forecastEndDate);
            let result: $TSFixMe = [];
            for (; year.isSameOrBefore(endDate, 'year'); year = year.add(1, 'years')) {
                if (year.isSame(startDate)) {
                    let i = startDate.quarter();
                    for (i; i <= 4; i++) {
                        let label = getChartLabel('Q-' + i, year);
                        result.push(label);
                    }
                } else {
                    if (year.isSame(endDate, 'year')) {
                        for (let i = 1; i <= endDate.quarter(); i++) {
                            let label = getChartLabel('Q-' + i, year);
                            result.push(label);
                        }
                    } else {
                        result = result.concat([getChartLabel('Q-1', year), getChartLabel('Q-2', year), getChartLabel('Q-3', year), getChartLabel('Q-4', year)]);
                    }
                }
            }
            return result;
        }

        function getChartLabel(label: $TSFixMe, yearDate: $TSFixMe) {
            let year = yearDate.format('YYYY');
            return label + '-' + year;
        }

        function prepareLabelsToQuartersTable(forecastStartDate: $TSFixMe, forecastEndDate: $TSFixMe) {
            
            let startDate = moment(forecastStartDate);
            
            let year = moment(forecastStartDate);
            
            let endDate = moment(forecastEndDate);
            let result = [];
            for (; year.isSameOrBefore(endDate, 'year'); year = year.add(1, 'years')) {
                let item = {
                    year: year.format('YYYY'),
                    quarters: []
                };

                if (year.isSame(startDate)) {
                    let i = startDate.quarter();
                    for (i; i <= 4; i++) {
                        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
                        item.quarters.push('Q-' + i)
                    }
                } else {
                    if (year.isSame(endDate, 'year')) {
                        for (let i = 1; i <= endDate.quarter(); i++) {
                            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
                            item.quarters.push('Q-' + i)
                        }
                    } else {
                        // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'never'.
                        item.quarters = ['Q-1', 'Q-2', 'Q-3', 'Q-4'];
                    }

                }

                result.push(item);
            }
            return result;
        }

        function prepareDataToCycleTable(forecastStartDate: $TSFixMe, forecastEndDate: $TSFixMe) {
            
            let startDate = moment(forecastStartDate),
                
                year = moment(forecastStartDate),
                
                endDate = moment(forecastEndDate),
                result = [];

            for (; year.isSameOrBefore(endDate, 'year'); year = year.add(1, 'years')) {
                let item = {
                    year: year.format('YYYY'),
                    cycles: []
                };
                if (year.isSame(startDate)) {
                    let i = Math.ceil(parseInt(startDate.format('M')) / 4);
                    for (i; i <= 3; i++) {
                        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
                        item.cycles.push('C-' + i)
                    }
                } else {
                    if (year.isSame(endDate, 'year')) {
                        for (let i = 1; i <= Math.ceil(parseInt(endDate.format('M')) / 4); i++) {
                            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
                            item.cycles.push('C-' + i)
                        }
                    } else {
                        // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'never'.
                        item.cycles = ['C-1', 'C-2', 'C-3'];
                    }
                }
                result.push(item);
            }
            return result;
        }

        function prepareCycleLabelsToChart(forecastStartDate: $TSFixMe, forecastEndDate: $TSFixMe) {
            
            let startDate = moment(forecastStartDate);
            
            let year = moment(forecastStartDate);
            
            let endDate = moment(forecastEndDate);
            let result: $TSFixMe = [];

            for (; year.isSameOrBefore(endDate, 'year'); year = year.add(1, 'years')) {
                if (year.isSame(startDate)) {
                    let i = Math.ceil(parseInt(startDate.format('M')) / 4);
                    for (i; i <= 3; i++) {
                        let label = getChartLabel('C-' + i, year);
                        result.push(label);
                    }
                } else {
                    if (year.isSame(endDate, 'year')) {
                        for (let i = 1; i <= Math.ceil(parseInt(endDate.format('M')) / 4); i++) {
                            let label = getChartLabel('C-' + i, year);
                            result.push(label);
                        }
                    } else {
                        result = result.concat([getChartLabel('C-1', year), getChartLabel('C-2', year), getChartLabel('C-3', year)]);
                    }
                }
            }
            return result;
        }

        function prepareDataToForecastTable(parameters: $TSFixMe, input: $TSFixMe, calculatedData: $TSFixMe, correctionsArray: $TSFixMe, compareForecast: $TSFixMe) {
            const result = [];
            
            const startDateMoment = moment.utc(parameters.forecastStartDate);
            
            const endDateMoment = moment.utc(parameters.forecastEndDate);

            let index = 0;

            for (let year = parameters.forecastStartDate.getFullYear(); year <= parameters.forecastEndDate.getFullYear(); year++) {
                const yearData = {
                    year,
                    data: [] as $TSFixMe[]
                };
                for (let month = 1; month <= 12; month++) {
                    
                    const monthDate = moment.utc(`${year}/${month}/1`, 'YYYY/MM/dd');
                    if (monthDate.isBetween(startDateMoment, endDateMoment, 'months', '[]')) {

                        const forecastIndex = monthDate.diff(startDateMoment, 'months');
                        
                        const correction = _.find(correctionsArray, (c: $TSFixMe) => monthDate.isBetween(moment.utc(c.startDate), moment.utc(c.endDate), 'month', '[]'));
                        if (correction) {

                            const correctionCopy = angular.copy(correction);
                            correctionCopy.correct = calculatedData[forecastIndex];
                            yearData.data.push({
                                index,
                                forecast: input[forecastIndex],
                                correctData: correctionCopy,
                                compareForecast: compareForecast ? compareForecast[forecastIndex] : null
                            });
                        } else {
                            yearData.data.push({
                                index,
                                correctData: null,
                                forecast: input ? input[forecastIndex] : null,
                                compareForecast: compareForecast ? compareForecast[forecastIndex] : null
                            });
                        }
                        ++index;
                    } else {
                        yearData.data.push(undefined);
                    }
                }
                result.push(yearData);
            }
            return result;
        }

        function getCorrectionAboutFactForTableExport(forecastData: $TSFixMe) {
            let result = {
                columns: [
                    $translate.instant("DTP_TABLE.MONTH.JANUARY"),
                    $translate.instant("DTP_TABLE.MONTH.FEBRUARY"),
                    $translate.instant("DTP_TABLE.MONTH.MARCH"),
                    $translate.instant("DTP_TABLE.MONTH.APRIL"),
                    $translate.instant("DTP_TABLE.MONTH.MAY"),
                    $translate.instant("DTP_TABLE.MONTH.JUNE"),
                    $translate.instant("DTP_TABLE.MONTH.JULY"),
                    $translate.instant("DTP_TABLE.MONTH.AUGUST"),
                    $translate.instant("DTP_TABLE.MONTH.SEPTEMBER"),
                    $translate.instant("DTP_TABLE.MONTH.OCTOBER"),
                    $translate.instant("DTP_TABLE.MONTH.NOVEMBER"),
                    $translate.instant("DTP_TABLE.MONTH.DECEMBER")
                ],
                rows: []
            };

            const baseDescription = $translate.instant("DTP_TABLE.DATA.BASE_FORECAST");
            const correctDescription = $translate.instant("DTP_TABLE.DATA.FORECAST_AFTER_CORRECT");

            for (const correct of forecastData) {
                const base = {
                    header: correct.year + ' ' + baseDescription,
                    
                    values: _.map(correct.data, (x: $TSFixMe) => x && x.forecast ? x.forecast : '')
                };
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ header: string; values: any; }... Remove this comment to see the full error message
                result.rows.push(base);

                const correctionRow = {
                    header: correct.year + ' ' + correctDescription,
                    
                    values: _.map(correct.data, (x: $TSFixMe) => x && x.correctData ? x.correctData.correct : '')
                };
                // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ header: string; values: any; }... Remove this comment to see the full error message
                result.rows.push(correctionRow);
            }
            return result;
        }


        function preparePMforecast(originalData: $TSFixMe, correction: $TSFixMe) {
            var result = [];
            for (var i = 0, max = originalData.length; i < max; i++) {
                if (typeof correction[i] === 'object' && correction[i] !== null && !isNaN(correction[i].correct)) {
                    result.push(correction[i].correct);
                } else {
                    result.push(originalData[i]);
                }
            }
            return result;
        }


        function prepareStatisticData(data: $TSFixMe, base: $TSFixMe, correct: $TSFixMe) {
            var result = {
                base: [],
                afterCorrect: []
            };
            for (var i = 0, max = data.length; i < max; i++) {

                angular.forEach(data[i], function (value: $TSFixMe, key: $TSFixMe) {
                    if (key == base) {
                        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                        result.base.push(value);
                    }
                    if (key == correct) {
                        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
                        result.afterCorrect.push(value);
                    }
                })
            }
            return result;
        }

        function prepareDataToChartPPG(histBase: $TSFixMe, forecBase: $TSFixMe, histCorr: $TSFixMe, forecCorr: $TSFixMe, quarters: $TSFixMe) {
            var dataToPPGChart = [],
                base: $TSFixMe = [],
                afterCorrect: $TSFixMe = [];

            var baseHistorical = quarters ? calculationPPGService.calculationQuartersPPG(histBase) : calculationPPGService.calculationPPG(histBase),
                historicalAfterCorrect = quarters ? calculationPPGService.calculationQuartersPPG(histCorr) : calculationPPGService.calculationPPG(histCorr),
                baseForecast = quarters ? calculationPPGService.calculationQuartersPPG(forecBase) : calculationPPGService.calculationPPG(forecBase),
                forecastAfterCorrect = quarters ? calculationPPGService.calculationQuartersPPG(forecCorr) : calculationPPGService.calculationPPG(forecCorr);

            dataToPPGChart[0] = base.concat(baseHistorical, baseForecast);
            dataToPPGChart[1] = afterCorrect.concat(historicalAfterCorrect, forecastAfterCorrect);

            if (quarters) {
                dataToPPGChart[0].unshift(undefined, undefined, undefined, undefined);
                dataToPPGChart[1].unshift(undefined, undefined, undefined, undefined);
            } else {
                dataToPPGChart[0].unshift(undefined);
                dataToPPGChart[1].unshift(undefined);
            }

            return dataToPPGChart;
        }

        function prepareDataToPPGYearlyTable(statisticalForecast: $TSFixMe, pmForecast: $TSFixMe, forecastStartMonth: $TSFixMe) {
            var pmForecastYearlyPPG = calculationPPGService.calculationPPGByYear(pmForecast, forecastStartMonth);
            var statisticalForecastYearlyPPG = calculationPPGService.calculationPPGByYear(statisticalForecast, forecastStartMonth);

            var dataToTablePPG = [];
            for (var i = 0; i < pmForecastYearlyPPG.length; i++) {
                dataToTablePPG.push({
                    base: statisticalForecastYearlyPPG[i],
                    correct: pmForecastYearlyPPG[i]
                });
            }
            return dataToTablePPG;
        }

        function prepareDataToQuartersPPGTable(statisticalForecast: $TSFixMe, pmForecast: $TSFixMe, forecastStartMonth: $TSFixMe) {
            
            var date = moment(forecastStartMonth);
            var statisticalForecastPPGQuaterData = calculationPPGService.calculationPPGByQuarter(statisticalForecast, forecastStartMonth);
            var pmForecastPPGQuaterData = calculationPPGService.calculationPPGByQuarter(pmForecast, forecastStartMonth);

            var result = [];
            var item = {
                year: date.format('YYYY'),
                data: [] as $TSFixMe[]
            };
            var quater = date.quarter();
            for (var q = 1; q < quater; q++) {
                item.data.push({});
            }
            for (var i = 0; i < statisticalForecastPPGQuaterData.length; i++) {
                if (item.year != date.format('YYYY')) {
                    result.push(item);
                    item = {
                        year: date.format('YYYY'),
                        data: []
                    };
                }
                item.data.push({
                    base: statisticalForecastPPGQuaterData[i],
                    correct: pmForecastPPGQuaterData[i]
                });

                date = date.add(3, 'months');
            }

            result.push(item);

            return result;
        }

        function sumQuarters(arr: $TSFixMe) {
            var result = [];
            var sum = 0;
            for (var i = 0, max = arr.length; i < max; i += 3) {
                var monthOne = arr[i] || {
                    forecast: 0
                },
                    monthTwo = arr[i + 1] || {
                        forecast: 0
                    },
                    monthThree = arr[i + 2] || {
                        forecast: 0
                    };
                sum = monthOne.forecast + monthTwo.forecast + monthThree.forecast;
                result.push(sum);
            }
            return result;
        }

        function sumQuartersCorrect(arr: $TSFixMe) {
            var result = [];
            var sum = 0;
            for (var i = 0, max = arr.length; i < max; i += 3) {

                var monthOne = getCorrectOrForecast(arr, i),
                    monthTwo = getCorrectOrForecast(arr, i + 1),
                    monthThree = getCorrectOrForecast(arr, i + 2);

                var one = isNaN(parseFloat(monthOne.correct || monthOne)) ? 0 : parseFloat(monthOne.correct || monthOne),
                    two = isNaN(parseFloat(monthTwo.correct || monthTwo)) ? 0 : parseFloat(monthTwo.correct || monthTwo),
                    three = isNaN(parseFloat(monthThree.correct || monthThree)) ? 0 : parseFloat(monthThree.correct || monthThree);

                sum = one + two + three;
                result.push(sum);
            }

            return result;
        }

        function getCorrectOrForecast(arr: $TSFixMe, i: $TSFixMe) {

            return arr[i] && (!angular.isUndefinedOrNull(arr[i].correctData) || !angular.isUndefinedOrNull(arr[i].forecast)) ?
                (arr[i].correctData || arr[i].forecast) : 0;
        }

        function preparePpgQuarterData(marketValue: $TSFixMe, marketStatisticalValue: $TSFixMe, dataStart: $TSFixMe) {
            return {
                itemPPG: calculationPPGService.calculationPPGByYear(marketValue, dataStart),
                itemStatisticalPPG: calculationPPGService.calculationPPGByYear(marketStatisticalValue, dataStart),
                quarterValue: calculationPPGService.sumBy(marketValue, dataStart, (month: $TSFixMe) => month % 3 == 0),
                quarterPPG: calculationPPGService.calculationPPGByQuarter(marketValue, dataStart),
                tangentQuarterPPG: calculationPPGService.calculationPPGByTangentsQuarter(marketValue, dataStart),
                statisticalQuarter: calculationPPGService.calculationPPGByQuarter(marketStatisticalValue, dataStart),
                statisticalTangentQuarter: calculationPPGService.calculationPPGByTangentsQuarter(marketStatisticalValue, dataStart)
            };
        }

        function sumArrayItems(arr: $TSFixMe) {
            return arr.filter((x: $TSFixMe) => !isNaN(x) && x !== null)
                .reduce((a: $TSFixMe, b: $TSFixMe) => parseFloat(a) + parseFloat(b), 0);
        }

        function fitTableToWrapper(name: $TSFixMe) {
            const parent = document.getElementById(name),
                // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                parentWidth = parent.offsetWidth,
                // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                childrenWidth = parent.children[0].offsetWidth;
            return childrenWidth < parentWidth;
        }

        function calculatePPG(parameters: $TSFixMe, historicalValue: $TSFixMe, pmForecast: $TSFixMe, statisticalForecast: $TSFixMe) {
            if (!parameters || !parameters.historicalDataStart || !parameters.forecastEndDate)
                return;

            if (!angular.isUndefinedOrNull(historicalValue) && !angular.isUndefinedOrNull(pmForecast)) {
                
                const historicalDataLength = Math.floor(moment.utc(parameters.historicalDataEnd).diff(moment.utc(parameters.historicalDataStart), 'months')) + 1;
                if (historicalValue.length < historicalDataLength) {
                    
                    historicalValue = historicalValue.concat(_.times(historicalDataLength - historicalValue.length, _.constant(null)));
                }

                const marketValue = historicalValue.concat(pmForecast);
                const marketStatisticalValue = historicalValue.concat(statisticalForecast);
                const ppgObj = preparePpgQuarterData(marketValue, marketStatisticalValue, parameters.historicalDataStart);
                const yearlySum = calculationPPGService.sumBy(marketValue, parameters.historicalDataStart, function (month: $TSFixMe) {
                    return month == 0;
                });
                return {
                    ppg: ppgObj,
                    yearlySum
                };
            } else {
                return {
                    ppg: {},
                    yearlySum: null
                }
            }
        }

        return {
            prepareLabelsToQuartersTable: prepareLabelsToQuartersTable,
            prepareDataToForecastTable: prepareDataToForecastTable,
            preparePMforecast: preparePMforecast,
            prepareStatisticData: prepareStatisticData,
            prepareDataToChartPPG: prepareDataToChartPPG,
            prepareLabelsToPPG: prepareLabelsToPPG,
            prepareQuartersLabelsToPPG: prepareQuartersLabelsToPPG,
            prepareDataToPPGYearlyTable: prepareDataToPPGYearlyTable,
            prepareDataToQuartersPPGTable: prepareDataToQuartersPPGTable,
            sumQuarters: sumQuarters,
            sumArrayItems: sumArrayItems,
            sumQuartersCorrect: sumQuartersCorrect,
            preparePpgQuarterData: preparePpgQuarterData,
            prepareDataToCycleTable: prepareDataToCycleTable,
            prepareCycleLabelsToChart: prepareCycleLabelsToChart,
            getCorrectionAboutFactForTableExport: getCorrectionAboutFactForTableExport,
            fitTableToWrapper: fitTableToWrapper,
            calculatePPG: calculatePPG
        };
    }

})(angular.module('topline.services'));